import { render, staticRenderFns } from "./bill-addr-migrate-form.vue?vue&type=template&id=6bb506b2&scoped=true"
import script from "./bill-addr-migrate-form.vue?vue&type=script&lang=js"
export * from "./bill-addr-migrate-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb506b2",
  null
  
)

export default component.exports